import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, ModalOpen, StateManager, useBCMSContext, useParams, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from 'components/shared/containers/FormContainer';
import { UICancelButton, UIPrimaryButton } from 'components/ui/UIButton';
import UIRadio from 'components/ui/UIRadio';
import UIExplanationTextInput from 'components/ui/UITextInput/components/UIExplanationTextInput';
import Classes, { Transaction } from 'model';
import React from 'react';
import DisputeProgressWidget from '../widgets/DisputeProgressWidget';
import "./styles.css";

/**
 * @function DisputeItemServiceView
 * @return {React.Component}
 * @exported true
 * @description The view that asks about the item being disputed.
 */

export default function DisputeItemServiceView(props){
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  const navigate = useRoute();
  const params = useParams();
  const { goStep, nextStep, prevStep, state } = useWorkflow() ?? {};
  const paramsTransactionID = useParams().transactionID ?? "0";
  const data = { ...getDefaultData(paramsTransactionID), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    update: type => (val, _label) => {
      const label = _label.toLowerCase();
      let reason = label;
      
      if(label.includes("merchandise")) {
        reason = "merchandise";
      } else if(label.includes("services or experiences")) {
        reason = "services or experiences";
      }

      BCMSStateManagerCRUD.init(state)
        .update([ "data", "dispute", type ], reason)
        .update([ "data", "didSelectRadioButton" ], true)
        .update([ "ui" ], ui)
        .submit(setState);
    },

    updateTextInput: type => (arg1, arg2, arg3) => {
      BCMSStateManagerCRUD.init(state)
        .update([ "data", "dispute", type ], arg1)
        .update([ "ui" ], ui)
        .submit(setState);
    },

    next: evt => {
      if(data.dispute.whatAreYouTryingToDispute === "merchandise") {
        goStep(3, { data, ui });
      } else {
        goStep(7, { data, ui });
      }
    },

    cancel: () => {
      navigate(`/home/transactiondetails/${ params.cardID }/${ params.transactionID }`);
    }
  });

  return(
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = transactionID => {
  const transaction = Transaction.initByID(transactionID);
  const dispute = BCMSDefaultModel.transactionDispute();
  dispute.transaction = transaction;

  return {
    dispute
  };
}

export const getDefaultUI = () => ({
  
});

function PageContent(props) {
  const { data, next, cancel, update, updateTextInput } = useStateManager();
  const dispute = data.dispute ?? {};

  const buttonItems = [
    { id: "0", label: "Merchandise (e.g. clothing, groceries, electronics, or other products)", dataPoint: "Selection_Merchandise", val: "merchandise" },
    { id: "1", label: "Services or experiences (e.g. reservations, rentals, digital subscriptions, e-tickets)", dataPoint: "Selection_Services", val: "services or experiences" }
  ];

  const radioButtons = buttonItems.reduce((acc, item) => {
      acc.push(
        <UIRadio key={ item.id } dataPoint={ item.dataPoint } value={ dispute.whatAreYouTryingToDispute === item.val } 
            label={ item.label } onChange={ update("whatAreYouTryingToDispute") } />
      );
      return acc;
  }, []);

  const nextButtonEnabled = dispute.whatAreYouTryingToDispute !== "" && dispute.whatDidYouPurchase !== "";

  const onCancel = evt => {
    cancel();
    //navigate(`/home/transactiondetails/${ params.cardID }/${ params.transactionID }`);
  }

  const textInputDataPoint = { dataPoint: "Text_Input_Product_Description" };
  const nextButtonDataPoint = { dataPoint: "Next_Button" };

  return (
    <div className="dispute-item-service-view">
        <DisputeProgressWidget step="0" />
        <FormContainer>
          <FormRow>
            <p className="form-label">What are you trying to dispute? *</p>
            { radioButtons }
            {/*<UIRadio label="Merchandise (e.g. clothing, groceries, electronics, or other products)" />
            <UIRadio label="Services or experiences (e.g. reservations, rentals, digital subscriptions, e-tickets)" />*/}
          </FormRow>
          <FormRow>
            <p className="form-label">What did you purchase? *</p>
            <UIExplanationTextInput { ...textInputDataPoint } maxLength="300" value={ dispute.whatDidYouPurchase } onChange={ updateTextInput("whatDidYouPurchase") } placeholder="Product description" className="has-placeholder" placeholderText="Provide information such as brand, model, color, and size." />
          </FormRow>
          <FormButtonContainer>
            <UIPrimaryButton text="Next" { ...nextButtonDataPoint } className={ nextButtonEnabled ? "" : "disabled" } onClick={ next } />
            <ModalOpen id="CancelDisputeTransactionModal" data={ { onCancel: onCancel } }>
              <UICancelButton text="Cancel" />
            </ModalOpen>
          </FormButtonContainer>
        </FormContainer>
    </div>
  );
}